import React from 'react';
import { LayoutProps } from '@/types/generalSettings';
import MegaMenuClient from './MegaMenuClient';

interface MegaMenuProps {
    item: LayoutProps.MenuItem;
    content: any; // The pre-fetched data
    brokerAd?: LayoutProps.BrokersAd[];
    exchangeForeignAd?: LayoutProps.BrokersAd[];
    exchangeIranianAd?: LayoutProps.BrokersAd[];
    propAd?: LayoutProps.BrokersAd[];
}

const MegaMenu: React.FC<MegaMenuProps> = ({
    item,
    content,
    brokerAd,
    exchangeForeignAd,
    exchangeIranianAd,
    propAd,
}) => {
    const tabs = item.childItems?.edges.map((edge) => edge.node).filter(Boolean) || [];

    if (tabs.length === 0) return null;

    return (
        <div className='w-fit transition-all bg-white dark:bg-primary-active rounded-2xl shadow-xl border border-gray-200 dark:border-white/10 overflow-hidden'>
            <MegaMenuClient
                tabs={tabs as LayoutProps.MenuItem[]}
                content={content}
                brokerAd={brokerAd}
                exchangeForeignAd={exchangeForeignAd}
                exchangeIranianAd={exchangeIranianAd}
                propAd={propAd}
            />
        </div>
    );
};

export default MegaMenu;
